var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "74ccd6cc396a1df46fd24c2dd7bde7a0e3b96bc5"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["butternutbox-frontend@butternut"] = {
  id: "74ccd6cc396a1df46fd24c2dd7bde7a0e3b96bc5"
};